<div [formGroup]="form" fxLayout="column" [fxLayoutGap]="LYT_GAP_VERTICAL">
  <div class="flex-wrap">
    <mat-form-field data-qa="abregelmoeglichkeit-form-field">
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_ABREGELMOEGLICHKEIT"
      ></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Abregelmöglichkeit</mat-label>
      <mat-select
        [redispatchDisableControl]="readonly"
        formControlName="abregelmoeglichkeit"
        data-qa="abregelmoeglichkeit"
        name="leistungsreduzierung">
        @for (r of funkrundsteuerEmpfaengerLeistungsreduzierungList; track r.key) {
          <mat-option
            data-qa="abregelmoeglichkeit-option"
            [value]="r.key" [disabled]="!isAbregelungstypEnabled(r.key)">
            {{ r.description }}
          </mat-option>
        }
      </mat-select>
      @if (f.abregelmoeglichkeit.hasError('required')) {
        <mat-error>
          Bitte wählen Sie eine Abregelmöglichkeit aus.
        </mat-error>
      }
      @if (f.abregelmoeglichkeit.hasError('steuerbareAbregelungRequired')) {
        <mat-error>
          Bitte wählen Sie eine steuerbare Abregelmöglichkeit aus. (Grund >=100 kW)
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly data-qa="regelstufen-form-field">
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_REGELSTUFE"
      ></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Regelstufen [%]</mat-label>
      <mat-select formControlName="regelstufen"
        [redispatchDisableControl]="readonly || isRegelstufenDisabled"
        data-qa="regelstufen"
        name="sr_regelstufen">
        @for (value of regelstufeItemList; track value.key) {
          <mat-option
            data-qa="regelstufen-option"
            [value]="value.key">
            {{ value.description }}
          </mat-option>
        }
      </mat-select>
      @if (f.regelstufen.hasError('required')) {
        <mat-error>
          Bitte wählen Sie eine Regelstufe aus.
        </mat-error>
      }
      @if (f.regelstufen.hasError('pattern')) {
        <mat-error>
          Die ausgewählte Regelstufe ist ungültig.
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div formGroupName="abregelungsinformationenFWA" [class.hidden]="!isLeistungsreduzierungFWA" fxLayout="column">
    <redispatch-form-group-headline [feld]="Feld.SUB_HEADER_FWA"></redispatch-form-group-headline>
    <div class="flex-wrap">
      <mat-form-field fxFlex="33">
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_FWA_FRE_ID_FERNWIRKGERAET"
        ></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>ID Fernwirkgerät (FRE, FWA)</mat-label>
        <input matInput
          [required]="isLeistungsreduzierungFWA"
          [redispatchDisableControl]="readonly || !isLeistungsreduzierungFWA"
          data-qa="idFernwirkgeraetFWA"
          formControlName="idFernwirkgeraet"
          name="idFernwirkgeraet">
        @if (fFwa.idFernwirkgeraet.hasError('required')) {
          <mat-error>
            Bitte geben Sie eine ID des Fernwirkgeräts ein.
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>


  <!-- Start: FRE -->
  <div formGroupName="abregelungsinformationenFRE" [class.hidden]="!isLeistungsreduzierungFRE" fxLayout="column" fxLayoutGap="1rem">
    <redispatch-form-group-headline [feld]="Feld.SUB_HEADER_FRE"></redispatch-form-group-headline>
    <div class="flex-wrap">
      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_FWA_FRE_ID_FERNWIRKGERAET"
        ></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>ID Fernwirkgerät (FRE, FWA)</mat-label>
        <input matInput
          [required]="isLeistungsreduzierungFRE"
          [redispatchDisableControl]="readonly || !isLeistungsreduzierungFRE"
          data-qa="idFernwirkgeraetFRE"
          formControlName="idFernwirkgeraet"
          name="idFernwirkgeraet">
        @if (fFre.idFernwirkgeraet.hasError('required')) {
          <mat-error>
            Bitte geben Sie eine ID des Fernwirkgeräts ein.
          </mat-error>
        }
        @if (fFre.idFernwirkgeraet.hasError('pattern')) {
          <mat-error>
            Die angegebene Zahl liegt nicht in den folgenden Zahlenbereichen (12300000-12399999, 5000000-5999999
            oder 20070000-20089999).
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_FRE_PLZ"
        ></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>Postleitzahl</mat-label>
        <input matInput
          [required]="isLeistungsreduzierungFRE"
          [redispatchDisableControl]="readonly || !isLeistungsreduzierungFRE"
          formControlName="funkrundsteuerPlz"
          data-qa="frepostleitzahl"
          name="funkrundsteuerEmpfaengerInformationen_funkrundsteuerPlz">
        @if (fFre.funkrundsteuerPlz.hasError('required')) {
          <mat-error>
            Bitte geben Sie eine Postleitzahl ein
          </mat-error>
        }
        @if (fFre.funkrundsteuerPlz.getError('minlength'); as error) {
          <mat-error>
            Postleitzahl zu kurz ({{ error.requiredLength }})
          </mat-error>
        }
        @if (fFre.funkrundsteuerPlz.getError('maxlength'); as error) {
          <mat-error>
            Postleitzahl zu lang ({{ error.requiredLength }})
          </mat-error>
        }
        @if (fFre.funkrundsteuerPlz.hasError('pattern')) {
          <mat-error>
            Bitte geben Sie eine fünfstellige Postleitzahl aus Deutschland ein
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_FRE_ANWENDERADRESSE"
        ></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>Anwenderadresse</mat-label>
        <input matInput
          [redispatchDisableControl]="readonly || !isLeistungsreduzierungFRE"
          [required]="isLeistungsreduzierungFRE"
          formControlName="anwenderadresse"
          data-qa="anwenderadresse"
          name="funkrundsteuerEmpfaengerInformationen_anwenderadresse">
        @if (fFre.anwenderadresse.hasError('required')) {
          <mat-error>
            Bitte geben Sie eine Anwenderadresse ein.
          </mat-error>
        }
        @if (fFre.anwenderadresse.hasError('freAnwenderadresseInvalid')) {
          <mat-error>
            Nur vordefinierte Anwenderadressen zulässig.
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="flex-wrap">
      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_FRE_ENERGIEART"
        ></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>Energieart</mat-label>
        <mat-select formControlName="energieart"
          [redispatchDisableControl]="readonly || !isLeistungsreduzierungFRE"
          [required]="isLeistungsreduzierungFRE"
          data-qa="energieart"
          (selectionChange)="checkEnergieartMatchesPrimaerenergietraeger($event.source.value)"
          name="funkrundsteuerEmpfaengerInformationen_energieart">
          @for (e of energieartList; track e.key) {
            <mat-option [value]="e.key">{{ e.description }}
            </mat-option>
          }
        </mat-select>
        @if (fFre.energieart.hasError('required')) {
          <mat-error>
            Bitte wählen Sie eine Energieart aus.
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_FRE_LEISTUNGSKLASSE"
        ></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>FRE Leistungsklasse</mat-label>
        <mat-select formControlName="leistungsklasse"
          [redispatchDisableControl]="readonly || !isLeistungsreduzierungFRE"
          [required]="isLeistungsreduzierungFRE"
          data-qa="leistungsklasse"
          name="funkrundsteuerEmpfaengerInformationen_leistungsklasse">
          @for (k of funkrundsteuerEmpfaengerLeistungsklasseList; track k.key) {
            <mat-option
              [value]="k.key">
              {{ k.description }}
            </mat-option>
          }
        </mat-select>
        @if (fFre.leistungsklasse.hasError('required')) {
          <mat-error>
            Bitte wählen Sie eine Leistungsklasse aus.
          </mat-error>
        }
      </mat-form-field>
    </div>

  </div>
  <!-- End: FRE -->

  <!-- Start: Tase2 -->
  <div formGroupName="abregelungsinformationenTase2" [class.hidden]="!isLeistungsreduzierungTase2">
    <redispatch-form-group-headline [feld]="Feld.SUB_HEADER_TASE2"></redispatch-form-group-headline>

    <redispatch-abregelinformationen-tase2-detail
      [disabled]="!isLeistungsreduzierungTase2"
      [readonly]="readonly">
    </redispatch-abregelinformationen-tase2-detail>
  </div>
  <!-- End: Tase2 -->

  <!-- Start:  ICE 101/104 -->
  <div formGroupName="abregelungsinformationenIEC101104" [class.hidden]="!isLeistungsreduzierungIEC101_104">
    <redispatch-form-group-headline [feld]="Feld.SUB_HEADER_IEC"></redispatch-form-group-headline>

    <redispatch-abregelinformationen-iec101104-detail
      [disabled]="!isLeistungsreduzierungIEC101_104"
      [readonly]="readonly">
    </redispatch-abregelinformationen-iec101104-detail>
  </div>
</div>
